import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Standardgemeinde extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    plz: number | null = null;
    ort: string | null = null;
    gemeinde_id: number | null = null;

    // view fields
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Standardgemeinde';
    }
}

export async function createNewStandardgemeinde(): Promise<Standardgemeinde> {
    const model = createModel(Standardgemeinde, {});

    await model.save();
    return model;
}

export class StandardgemeindeCollection extends BaseCollection<Standardgemeinde> {
    protected modelCls = Standardgemeinde;

    public getModelClassName(): string {
        return 'Standardgemeinde';
    }
}
